import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import HotRecommendations from './components/HotRecommendations';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <LatestUpdates />
        <HotRecommendations />
      </main>
      <Footer />
    </>
  );
}